export const loadNewRelic = () => {
  const env = process.env.NODE_ENV;
  if (
    !process.env.REACT_APP_NEW_RELIC_AGENT_ID ||
    !process.env.REACT_APP_NEW_RELIC_LICENSE_KEY ||
    !process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID
  ) {
    console.warn('Missing New Relic config');
    return;
  }

  const config = {
    accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
  };

  if (!config) {
    console.warn('Missing New Relic config for env:', env);
    return;
  }

  const configScript = document.createElement('script');
  configScript.type = 'text/javascript';
  configScript.innerHTML = `
    window.NREUM = {
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] }
      },
      loader_config: {
        accountID: "${config.accountID}",
        trustKey: "1248339",
        agentID: "${config.agentID}",
        licenseKey: "${config.licenseKey}",
        applicationID: "${config.applicationID}"
      },
      info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "${config.licenseKey}",
        applicationID: "${config.applicationID}",
        sa: 1
      }
    };
  `;

  const loaderScript = document.createElement('script');
  loaderScript.src =
    'https://js-agent.newrelic.com/nr-loader-spa-1.286.0.min.js';
  loaderScript.async = true;

  document.head.appendChild(configScript);
  document.head.appendChild(loaderScript);
};
